import React from 'react';
import './FAQ-page.scss';
import faqBanner from "../../assets/img/faq-banner.png"

function FaqPage(props) {
    return (
        <div className={'faq-page-wrapper'}>
            <section className={'section'}>
                {}
                <div className={'faq-hero'}>
                    <img 
                        src={faqBanner} 
                        alt="FAQs Coming Soon" 
                        className={'faq-banner-img'} 
                    />
                </div>
            </section>
        </div>
    );
}

export default FaqPage;